import { Button, type ButtonKind } from "./Button";
import { Modal } from "./Modal";

interface Props {
  title: string;
  message: React.ReactNode;
  onConfirm: () => void;
  onCancel: () => void;
  confirmKind?: ButtonKind;
  confirmText: string | null;
  cancelKind?: ButtonKind;
  cancelText: string | null;
  loading?: boolean;
}

/**
 * Uses <Modal> to alert the user and ask are you sure
 */
export const ModalAlert: React.FC<Props> = ({
  title,
  message,
  onConfirm,
  onCancel,
  confirmKind,
  confirmText,
  cancelKind,
  cancelText,
  loading,
}) => {
  const handleConfirm = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    onConfirm();
  };
  const handleCancel = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    onCancel();
  };

  return (
    <Modal title={title} onClose={onCancel} portal>
      <div className="flex flex-col items-center gap-6">
        <div>{message}</div>
        <div className="flex justify-center space-x-2">
          {confirmText && (
            <Button kind={confirmKind} onClick={handleConfirm} disabled={loading} spinner={loading}>
              {confirmText}
            </Button>
          )}
          {cancelText && (
            <Button kind={cancelKind} onClick={handleCancel} disabled={loading}>
              {cancelText}
            </Button>
          )}
        </div>
      </div>
    </Modal>
  );
};
